import { MODEL_FEEDBACK_MIN_COMMENT_LENGTH as MIN_COMMENT_LENGTH } from 'Pods/ThreeDStudio/constants'

// Mirrors Generator::RunFeedback#normalize_comment and #comment_has_content so the form
// flags a comment the API would reject. Ruby's strip, split and \s only cover ASCII
// whitespace, and the utf8mb3 column drops characters outside the BMP (emoji).
const NON_BMP_CHARACTERS = /[\u{10000}-\u{10FFFF}]/gu
const ASCII_WHITESPACE = /[\t\n\v\f\r ]+/g
const EDGE_WHITESPACE = /^[\0\t\n\v\f\r ]+|[\0\t\n\v\f\r ]+$/g
// Chinese and Japanese are written without spaces, so the word count cannot apply to them.
const CJK_CHARACTERS = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]/u
const LETTER = /\p{L}/u
const MIN_COMMENT_WORDS = 3

export const COMMENT_ERROR = { MIN_LENGTH: 'minLength', CONTENT: 'content' }

// The comment as the API stores it. Used for both the check and the payload, so a
// comment that passes here cannot change length on its way to the server.
export const normalizeComment = comment => comment.replace(NON_BMP_CHARACTERS, '').replace(EDGE_WHITESPACE, '')

export default function getCommentError(comment) {
  const normalized = normalizeComment(comment)

  if (normalized.length < MIN_COMMENT_LENGTH) return COMMENT_ERROR.MIN_LENGTH

  const words = normalized.split(ASCII_WHITESPACE).filter(Boolean)
  const hasEnoughWords = CJK_CHARACTERS.test(normalized) || words.length >= MIN_COMMENT_WORDS
  const distinctCharacters = new Set(normalized.replace(ASCII_WHITESPACE, '')).size

  if (!hasEnoughWords || !LETTER.test(normalized) || distinctCharacters <= 1) return COMMENT_ERROR.CONTENT

  return null
}
